{
  "url": "https://keycloak.testing.catalyst.intellecteu.io",
  "realm": "canton-dev",
  "clientId": "canton-ui",
  "authority": "https://keycloak.testing.catalyst.intellecteu.io/auth/realms/canton-dev",
  "audience": ""
}
